import type { ComponentProps } from "react";
import photoUrl from "@/assets/luke-and-dog.jpeg";
import { GitHubIcon, HeartIcon, LinkedInIcon, XIcon } from "@/components/icons";
import { Button } from "@/components/ui/button";
import { site } from "@/lib/site";

const SOCIAL_ICONS: Record<string, (props: ComponentProps<"svg">) => React.JSX.Element> = {
    GitHub: GitHubIcon,
    LinkedIn: LinkedInIcon,
    Twitter: XIcon,
};

export function ProfileCard() {
    return (
        <div
            className="grid max-w-[880px] gap-9.5 rounded-md border border-white/22 bg-white/5 p-9
                wide:grid-cols-[300px_1fr] wide:items-start"
        >
            {/* `isolate`, the panel color and `overflow-hidden` must stay on this same
                element: the photo blends with `lighten`, and without the isolation the
                blend composites against the cobalt page and the photo goes purple. */}
            <div className="isolate h-80 w-full overflow-hidden rounded-md bg-kt-panel wide:size-75">
                <img
                    src={photoUrl}
                    alt="Luke Bunselmeyer"
                    width={1200}
                    height={823}
                    fetchPriority="high"
                    decoding="async"
                    className="block size-full object-cover object-[64%_45%] mix-blend-lighten"
                />
            </div>

            <div className="flex flex-col gap-5 pt-1">
                <div>
                    <h2 className="text-[30px] font-medium tracking-name text-white">
                        Luke Bunselmeyer
                    </h2>
                    <p className="mt-[9px] text-[13px] uppercase tracking-caps text-kt-accent">
                        Founder &amp; solo developer
                    </p>
                </div>

                {/* Flat hairline -- deliberately not the fading rule used page-wide. */}
                <div role="presentation" className="h-px bg-white/16" />

                <p className="text-base leading-[1.65] text-kt-ink/78">
                    I'm a full-stack software engineer who{" "}
                    {/* role="img" + aria-label is the correct accessible name for an
                        inline SVG; jsx-a11y/prefer-tag-over-role disagrees and is
                        disabled in .oxlintrc.json for exactly this case. */}
                    <HeartIcon
                        role="img"
                        aria-hidden={undefined}
                        aria-label="loves"
                        className="mx-[2px] inline-block size-4.5 align-[-3px] fill-kt-accent"
                    />{" "}
                    creating delightful software products.
                </p>

                <div className="flex gap-2.5 self-start">
                    {site.socials.map((social) => {
                        const Icon = SOCIAL_ICONS[social.label];
                        return (
                            <Button
                                key={social.label}
                                asChild
                                variant="brand-icon"
                                size="brand-icon"
                            >
                                <a href={social.href} aria-label={social.label}>
                                    {Icon ? <Icon className="size-5" /> : null}
                                </a>
                            </Button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
